import axios from "axios";
// import DecryptData from "../Components/Utils/Decrypt";

const SERVER_URL = window.BASE_SOCKET_SERVER_URL || "";
const SOCKET_PATH = window.SOCKET_PATH || "";

const socketAxiosInstance = axios.create({
  baseURL: SERVER_URL + SOCKET_PATH,
});

// Request interceptor to add the token to every request
// socketAxiosInstance.interceptors.request.use(
//   (config) => {
//     const token = DecryptData("nEkOtReSuEdArT") || "";
//     if (token) {
//       config.headers.token = token;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

export default socketAxiosInstance;

